/**
 * @author Fernando Ruano
 * @file actions.js
 * @description BloodPressure Actions
 */

// Constants
import {
  GET_ALL_BLOOD_PRESSURES,
  CREATE_BLOOD_PRESSURE,
  UPDATE_BLOOD_PRESSURE,
  GET_BLOOD_PRESSURE_BY_ID,
  GET_BLOOD_PRESSURE_BY_PATIENT_ID,
  DELETE_BLOOD_PRESSURE_BY_ID
} from './constants';

/**
 * Call process to get all patients list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_BLOOD_PRESSURES
 */
export const getBloodPressuresArray = (data, callback) => ({
  type: GET_ALL_BLOOD_PRESSURES,
  payload: { data },
  callback
});

/**
 * Call process to get blood pressure by id
 * @param  { object } data - BloodPressure Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_BLOOD_PRESSURE_BY_ID
 */
export const getBloodPressureById = (data, callback) => ({
  type: GET_BLOOD_PRESSURE_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to get blood pressure by patient id
 * @param  { object } data - Patient Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_BLOOD_PRESSURE_BY_PATIENT_ID
 */
export const getBloodPressureByPatientId = (data, callback) => ({
  type: GET_BLOOD_PRESSURE_BY_PATIENT_ID,
  payload: { data },
  callback
});

/**
 * Call process to create blood pressure
 * @param  { object } data - BloodPressure Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_BLOOD_PRESSURE
 */
export const createBloodPressure = (data, callback) => ({
  type: CREATE_BLOOD_PRESSURE,
  payload: { data },
  callback
});

/**
 * Call process to update blood pressure
 * @param  { object } data - BloodPressure Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_BLOOD_PRESSURE
 */
export const updateBloodPressure = (data, callback) => ({
  type: UPDATE_BLOOD_PRESSURE,
  payload: { data },
  callback
});

/**
 * Call process to delete blood pressure
 * @param  { object } data - BloodPressure Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of DELETE_BLOOD_PRESSURE_BY_ID
 */
export const deleteBloodPressureById = (data, callback) => ({
  type: DELETE_BLOOD_PRESSURE_BY_ID,
  payload: { data },
  callback
});
